import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../../constants";
import { FaSpinner } from "react-icons/fa";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Select from "react-select";

const Department = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Department"));
  }, []);
  const [searchTerm, setSearchTerm] = useState("");
  const [holiday, setHoliday] = useState([]);
  const [submitted, setSubmit] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [formData, setFormData] = useState({
    Name: "",
    Code: "",
    Description: "",
    ParentDeptID: "",
  });

  const columns = {
    Code: { text: "Code", align: "start", visible: true },
    Name: { text: "Name", align: "start", visible: true },
    Description: { text: "Description", align: "Start", visible: true },
    ParentDept: { text: "Parent Department", align: "start", visible: true},
  };
  const defaultColumns = {
    Code: true,
    Name: true,
    Description: true,
    ParentDept: true,
  };

  const handleEdit = async (id) => {
    setShowModal(true);
    setIsEditMode(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}departmentmaster/${id.ID}`
      );

      if (response.status === 200) {
        const depData = response?.data?.data;

        if (depData) {
          const { Name, Code, Description, ParentDeptID} = depData;
          // Update form data with fetched values
          setFormData({
            id: id.ID, // Assuming `id.ID` is the identifier
            Name: Name || "",
            Code: Code || "",
            Description: Description || "",
            ParentDeptID: depData?.ParentDeptID || "",
          });
        }
      } else {
        console.error(
          "Failed to fetch Department details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Department details:", error);
    }
  };

  const fetchHoliday = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}departmentmaster`);
      const data = response?.data?.data;
      setHoliday(data);
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };
  
  const fetchDepartments = async () => {
  try {
    const response = await GetServiceCaller(`${API_URL}departmentmaster`);
    const data = response?.data?.data || [];

    const options = data.map((dept) => ({
      value: dept.ID,
      label: dept.Name,
    }));

    setDepartmentOptions(options);
  } catch (error) {
    console.log("Error fetching departments:", error);
  }
  };

  useEffect(() => {
    fetchHoliday();
    fetchDepartments();
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });

        if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const resetFormState = () => {
    setFormData({
      Name: "",
      Code: "",
      Description: "",
      ParentDeptID: "",
    });
    setIsEditMode(false); // Reset edit mode state
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.Code) newErrors.Code = "Code is required";
    if (!formData.Name) newErrors.Name = "Name is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      const method = isEditMode ? "put" : "post";
      const apiUrl = isEditMode
        ? `${API_URL}departmentmaster/${formData.id}`
        : `${API_URL}departmentmaster`;

      try {
        const response = await PostServiceCaller(apiUrl, formData, method);

        if (method === "post") {
          toast.success("Form submitted successfully!");
        } else {
          toast.success("Form updated successfully!");
        }
        resetFormState();
        fetchHoliday();
        setIsEditMode(false);
        setShowModal(false);
      } catch (error) {
        console.error("There was an error submitting the form data!", error);
        toast.error("Error submitting form data.");
      }
    }
  };

  const handleEditModalClose = () => {
    setShowModal(false);
    resetFormState();
  };

  const handleAddForm = () => {
    resetFormState();
    setShowModal(true);
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              data={holiday}
              columns={columns}
              defaultColumns={defaultColumns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              isSorting={true}
              isAddNewBtnRequired={true}
              isActionRequired={true}
              handleAddNew={handleAddForm}
              handleIcon1={handleEdit}
              icons={{
                Icon1: <i className="bi bi-pencil-square icons"></i>,
              }}
            />
          </div>
        </div>
        {/* Bootstrap Modal */}
        {showModal && (
          <div
            className="modal"
            tabIndex="-1"
            role="dialog"
            style={{
              display: "block",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <div className="modal-dialog modal-dialog-centered modal-md" role="document">
              <div className="modal-content">
                <div
                  className="modal-header"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #f0f0f0",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px 8px 0 0",
                  }}
                >
                  <p
                    style={{
                      fontSize: "16px",

                      fontWeight: "600",

                      color: "#27568B",

                      margin: "0",
                    }}
                  >
                    {isEditMode ? "Edit Department" : "Add Department"}
                  </p>

                  <span
                    className="me-2"
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "18px",
                      color: "#000",
                      padding: "4px",
                      borderRadius: "4px",
                      transition: "all 0.2s",
                      lineHeight: "1",
                    }}
                  >
                    <i
                      className="bi bi-x-lg"
                      onClick={handleEditModalClose}
                    ></i>
                  </span>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-4">
                        <div class="mb-3">
                          <label for="Code" class="form-label">
                            Code<span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              errors.Code ? "is-invalid" : ""
                            }`}
                            id="Code"
                            aria-describedby="Code"
                            name="Code"
                            placeholder="Code"
                            value={formData.Code}
                            onChange={handleInputChange}
                          />
                          {errors.Code && (
                            <div className="invalid-feedback">
                              {errors.Code}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-8">
                        <div class="mb-3">
                          <label for="Code" class="form-label">
                            Name<span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              errors.Name ? "is-invalid" : ""
                            }`}
                            id="Name"
                            aria-describedby="Name"
                            name="Name"
                            placeholder="Name"
                            value={formData.Name}
                            onChange={handleInputChange}
                          />
                          {errors.Name && (
                            <div className="invalid-feedback">
                              {errors.Name}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12">
                        <div class="mb-3">
                          <label for="Code" class="form-label">
                            Description
                          </label>
                          <textarea
                            type="text"
                            class="form-control"
                            id="Description"
                            aria-describedby="Description"
                            name="Description"
                            placeholder="Description"
                            value={formData.Description}
                            onChange={handleInputChange}
                          ></textarea>
                        </div>
                      </div>
                      {/* soc for adding parent department  */}
                      <div className="col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Parent Department
                          </label>

                          <Select
                            name="ParentDeptID"
                            value={departmentOptions.find(
                              (option) => option.value === formData.ParentDeptID
                            )}
                            onChange={(selectedOption) => {
                              setFormData({
                                ...formData,
                                ParentDeptID: selectedOption ? selectedOption.value : "",
                              });
                            }}
                            options={[
                              { value: "", label: "Select Department" },
                              ...departmentOptions,
                            ]}
                            isSearchable={true}
                            placeholder="Select Department"
                          />

                          {errors.ParentDeptID && (
                            <div className="text-danger">{errors.ParentDeptID}</div>
                          )}
                        </div>
                      </div>
                      {/* eoc */}
                    </div>

                    <div className="text-end mt-2">
                      <button
                        className="cancel-btn me-2"
                        onClick={handleEditModalClose}
                      >
                        Cancel
                      </button>
                      {showSubmitButton && (
                        <button type="submit" className="custom-btn">
                          {submitted ? (
                            <FaSpinner class="sm-spinner" />
                          ) : (
                            "Submit"
                          )}
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Department;
